import { PASSPORT, EEP, OTHERS } from '../constants';

export default {
  en: [
    { value: PASSPORT, label: 'Passport' },
    { value: EEP, label: 'Exit/Entry permit to Hong Kong and Macau' },
    { value: OTHERS, label: 'Others' },
  ],
  zh_CN: [
    { value: PASSPORT, label: '护照' },
    { value: EEP, label: '往来港澳通行证' },
    { value: OTHERS, label: '其他' },
  ],
  zh_HK: [
    { value: PASSPORT, label: '護照' },
    { value: EEP, label: '往來港澳通行證' },
    { value: OTHERS, label: '其他' },
  ]
}
